// extracted by mini-css-extract-plugin
module.exports = {"column":"TableColumn_column__20O6r","clickable":"TableColumn_clickable__1UiuY"};